import { type AuthProvider, useAuth } from '@entities/auth'
import { KakaoIcon } from '@shared/ui/icons'
import { FcGoogle } from 'react-icons/fc'

export function ProfileSection() {
  const { user } = useAuth()

  const nickname = user?.nickname ?? '사용자'

  return (
    <section className="px-4 mb-section-gap">
      {user?.provider && <ProviderBadge provider={user.provider} className="mb-1" />}
      <strong className="typo-heading break-keep font-bold inline-block text-foreground">
        {nickname}님, 안녕하세요!
      </strong>
    </section>
  )
}

function ProviderBadge({
  provider,
  className = '',
}: {
  readonly provider: AuthProvider
  readonly className?: string
}) {
  return (
    <span
      className={`flex items-center w-fit gap-0.5 rounded-sm border border-border px-1 ${className}`}
    >
      {provider === 'KAKAO' ? (
        <KakaoIcon className="text-footnote" aria-hidden="true" />
      ) : (
        <FcGoogle className="text-footnote" aria-hidden="true" />
      )}
      <span className="typo-footnote text-footnote text-muted-foreground">
        {provider === 'KAKAO' ? '카카오' : '구글'}
      </span>
    </span>
  )
}
